import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getClientKeyWithAccessToken } from '../lib/security'

const baseUrl = process.env.REACT_APP_BASEURL
const msIdentityApiUrl = process.env.REACT_APP_MS_IDENTITY_API

const rawBaseQuery = fetchBaseQuery({ baseUrl })

const baseQuery = async (args, api, extraOptions) => {
  const { accessToken } = api.getState().login
  const clientKey = await getClientKeyWithAccessToken(accessToken)
  // Si es el endpoint enableMfa, usamos el header x-api-ley
  if (typeof args === 'object' && args.url?.includes('/user/enableMfa')) {
    const headers = new Headers()
    headers.set('x-api-key', clientKey)
    headers.set('Content-Type', 'application/json')
    return rawBaseQuery({ ...args, headers }, api, extraOptions)
  }

  // Caso general: usamos el header client-key cuando existe
  const headers = new Headers()
  headers.set('Authorization', `Bearer ${accessToken}`)
  headers.set('Content-Type', 'application/json')
  if (clientKey) headers.set('client-key', clientKey)

  return rawBaseQuery({ ...args, headers }, api, extraOptions)
}

export const loginApi = createApi({
  reducerPath: 'loginApi',
  baseQuery,
  tagTypes: ['UserServices'],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ userEmail, userPassword, otp }) => ({
        url: `${baseUrl}/auth/login`,
        method: 'POST',
        body: JSON.stringify({
          email: userEmail,
          password: userPassword,
          ...(otp && { otp }),
        }),
      }),
    }),
    verifyMFA: builder.mutation({
      query: ({ otp, userEmail, userPassword }) => ({
        url: `${msIdentityApiUrl}/mfa/enroll/verify`,
        method: 'POST',
        body: JSON.stringify({ otpFromUser: otp, email: userEmail, password: userPassword }),
      }),
    }),
    activateMFA: builder.mutation({
      query: (userEmail) => {
        return {
          url: `${baseUrl}/user/enableMfa`,
          method: 'POST',
          body: JSON.stringify({ email: userEmail }),
          responseHandler: (response) => response.text(),
        }
      },
    }),
    resetMFA: builder.mutation({
      query: (userEmail) => {
        return {
          url: `${baseUrl}/user/resetMfa`,
          method: 'POST',
          body: JSON.stringify({ email: userEmail }),
          responseHandler: (response) => response.text(),
        }
      },
    }),
    updateAuth0Password: builder.mutation({
      query: ({ otp, userEmail, userPassword }) => ({
        url: `${msIdentityApiUrl}/users/updatePassword`,
        method: 'PUT',
        body: JSON.stringify({ otpFromUser: otp, email: userEmail, password: userPassword }),
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useVerifyMFAMutation,
  useActivateMFAMutation,
  useResetMFAMutation,
  useUpdateAuth0PasswordMutation,
} = loginApi

export default loginApi
